export default __webpack_public_path__ + "static/media/client2.c6ab74d9.png";